import React from 'react';
import { Box, Grid } from '@mui/material';
import { OnboardingGuides } from './components/OnboardingGuides';
import { HelpDesk } from './components/HelpDesk';
import { TrainingVideos } from './components/TrainingVideos';
import { Glossary } from './components/Glossary';

export const TrainingCenter: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 2,
        height: '100%'
      }}
    >
      <Box component="h1" sx={{ typography: 'h4', m: 0, fontWeight: 500 }}>
        Training & Support Center
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <OnboardingGuides />
        </Grid>
        <Grid item xs={12} md={4}>
          <HelpDesk />
        </Grid>
        <Grid item xs={12}>
          <TrainingVideos />
        </Grid>
        <Grid item xs={12}>
          <Glossary />
        </Grid>
      </Grid>
    </Box>
  );
};